define([
	"dojo/_base/declare",
	"csi",
	"csi/heading/AttributeController"
], function(declare,csi,AttributeController) {

	return declare(AttributeController, {
		getStringParameters: function() {
			// summary: return name of node containing filters for confirmation message
			return [this.getNode().$Name];
		},

		_toWriterValue: function(/*String*/id, /*String*/type) {
			// summary: delete the node and set the reference to an empty one
			this.m_writer.deleteNode(this.oldValue);
			this.newValue = csi.EMPTY_URL;
			return this.inherited(arguments);
		}
	});
});